
/**
 * @description
 * 로드맵 상세페이지 > 로드맵 수업 > 참여했어요 스탬프
 */
export default {
  name: 'GreatStamp',
  data() {
    return {
      stampImg: require('@/assets/img/course/stamp.png'),
    };
  },
};
